import { boolean, constant, DecoderType, either, nullable, number, object, string } from "decoders";
import { jsendResponseDecoder } from "Utils/jsend";
import { IdValidation, requiredValidation } from "Utils/validations";
import * as Yup from "yup";

import { Decoder } from "decoders";
import { JsendSuccess, jsendSuccessDecoder } from "Utils/jsend";
import { distributionDecoder } from "../register/interfaces";

export type LoginStatus = "login" | "otp";

export interface LoginFormData {
  clientId: string;
  password: string;
}

export interface LoginData extends LoginFormData {
  status: LoginStatus;
  uid?: string;
  token?: string;
}

export const userDecoderKey = object({
  pk: number,
  username: string,
  first_name: string,
  last_name: string,
  email: string,
  full_name: string,
  is_active: boolean,
  last_login: nullable(string),
  role: string,
  role_id: nullable(number),
  affiliated_institution: boolean,
  lead_id: string,
  signature: object({
    pending: boolean,
    isDigital: boolean,
    message: string,
  }),
  conciliation: object({
    pending: boolean,
    initialFees: object({
      affiliationFees: number,
      distribution: distributionDecoder,
    }),
  }),
});

export type UserData = DecoderType<typeof userDecoderKey>;

export const loginDataKeys: ["clientId", "password"] = ["clientId", "password"];

const baseReponseFailDecoder = object({
  errorKey: string,
  message: string,
});

export type BaseResponseFail = DecoderType<typeof baseReponseFailDecoder>;

const tokenDecoders = {
  access: string,
};

const loginResponseSuccessDecoder = either(
  object({
    needOtp: constant(true),
    uid: string,
    token: string,
  }),
  object({
    needOtp: constant(false),
    ...tokenDecoders,
    refresh: string,
    user: userDecoderKey,
  })
);

export type LoginResponseSuccess = DecoderType<typeof loginResponseSuccessDecoder>;

export const loginResponseDecoder = jsendResponseDecoder(loginResponseSuccessDecoder, baseReponseFailDecoder);

export type LoginResponse = DecoderType<typeof loginResponseDecoder>;

const getTokenDataDecoder = object({
  ...tokenDecoders,
  refresh: string,
  user: userDecoderKey,
});

export type GetTokenData = DecoderType<typeof getTokenDataDecoder>;

export const getTokenResponseDecoder = jsendResponseDecoder(getTokenDataDecoder, baseReponseFailDecoder);

export type GetTokenResponse = DecoderType<typeof getTokenResponseDecoder>;

export const refreshTokenDecoder = object({
  ...tokenDecoders,
});

export type RefreshTokenResponse = DecoderType<typeof refreshTokenDecoder>;

export const getCurrentUserResponseDecoder = jsendResponseDecoder(userDecoderKey, string);

export type GetCurrentUserResponse = DecoderType<typeof getCurrentUserResponseDecoder>;

export const loginDataSchema = Yup.object({
  [loginDataKeys[0]]: IdValidation,
  [loginDataKeys[1]]: requiredValidation,
});

export interface TokenErrorResponseMessage {
  token_class: string;
  token_type: string;
  message: string;
}

export interface TokenErrorResponse {
  detail: string;
  code: string;
  messages?: TokenErrorResponseMessage[];
}

export const verifyTokenDecoder = object({});

export type VerifyTokenResponse = DecoderType<typeof verifyTokenDecoder>;

export type LogoutResponse = JsendSuccess<string>;
export const logoutResponseDecoder: Decoder<LogoutResponse> = jsendSuccessDecoder(string);
